import './IndustriesSection.css';
import industriesBg from './industries-bg.jpg';

const industries = [
  {
    title: 'Lending & NBFCs',
    body: 'Disburse loans in seconds and reconcile EMI collections on one ledger.',
    icon: (
      <svg xmlns="http://www.w3.org/2000/svg" width="23" height="23" viewBox="0 0 23 23" fill="none">
        <rect x="2" y="5.75" width="19" height="11.5" rx="2" stroke="#0043FE" strokeWidth="1.91667" strokeLinecap="round" strokeLinejoin="round"/>
        <circle cx="11.5" cy="11.5" r="2.875" stroke="#0043FE" strokeWidth="1.91667" strokeLinecap="round" strokeLinejoin="round"/>
        <path d="M6.70825 11.5H6.71825" stroke="#0043FE" strokeWidth="1.91667" strokeLinecap="round" strokeLinejoin="round"/>
        <path d="M16.2917 11.5H16.3017" stroke="#0043FE" strokeWidth="1.91667" strokeLinecap="round" strokeLinejoin="round"/>
      </svg>
    ),
  },
  {
    title: 'Insurance',
    body: 'Settle claims and premium refunds in minutes, with a full audit trail.',
    icon: (
      <svg xmlns="http://www.w3.org/2000/svg" width="23" height="23" viewBox="0 0 23 23" fill="none">
        <path d="M11.5 2C11.5 2 18.5 5 18.5 9.5V15C18.5 18.5 11.5 21 11.5 21C11.5 21 4.5 18.5 4.5 15V9.5C4.5 5 11.5 2 11.5 2Z" stroke="#0043FE" strokeWidth="1.91667" strokeLinecap="round" strokeLinejoin="round"/>
        <path d="M8.5 11L10.5 13L15 8.5" stroke="#0043FE" strokeWidth="1.91667" strokeLinecap="round" strokeLinejoin="round"/>
      </svg>
    ),
  },
  {
    title: 'E-commerce',
    body: 'Pay thousands of sellers on schedule, with penny-drop checks.',
    icon: (
      <svg xmlns="http://www.w3.org/2000/svg" width="23" height="23" viewBox="0 0 23 23" fill="none">
        <path d="M5.75 1.91699L2.875 5.75033V19.167C2.875 19.6753 3.07693 20.1628 3.43638 20.5223C3.79582 20.8817 4.28334 21.0837 4.79167 21.0837H18.2083C18.7167 21.0837 19.2042 20.8817 19.5636 20.5223C19.9231 20.1628 20.125 19.6753 20.125 19.167V5.75033L17.25 1.91699H5.75Z" stroke="#0043FE" strokeWidth="1.91667" strokeLinecap="round" strokeLinejoin="round"/>
        <path d="M2.875 5.75H20.125" stroke="#0043FE" strokeWidth="1.91667" strokeLinecap="round" strokeLinejoin="round"/>
        <path d="M15.3334 9.58301C15.3334 10.5997 14.9295 11.5747 14.2107 12.2936C13.4918 13.0125 12.5167 13.4163 11.5001 13.4163C10.4834 13.4163 9.50839 13.0125 8.78951 12.2936C8.07062 11.5747 7.66675 10.5997 7.66675 9.58301" stroke="#0043FE" strokeWidth="1.91667" strokeLinecap="round" strokeLinejoin="round"/>
      </svg>
    ),
  },
  {
    title: 'Logistics & Delivery',
    body: 'Pay delivery and gig partners every day across IMPS and UPI.',
    icon: (
      <svg xmlns="http://www.w3.org/2000/svg" width="23" height="23" viewBox="0 0 23 23" fill="none">
        <rect x="1.5" y="4.5" width="13.5" height="11.5" rx="1.5" stroke="#0043FE" strokeWidth="1.91667" strokeLinecap="round" strokeLinejoin="round"/>
        <polygon points="15 9 19 9 21.5 11.5 21.5 16 15 16 15 9" stroke="#0043FE" strokeWidth="1.91667" strokeLinecap="round" strokeLinejoin="round"/>
        <circle cx="5.5" cy="18.5" r="2" stroke="#0043FE" strokeWidth="1.91667" strokeLinecap="round" strokeLinejoin="round"/>
        <circle cx="17.5" cy="18.5" r="2" stroke="#0043FE" strokeWidth="1.91667" strokeLinecap="round" strokeLinejoin="round"/>
      </svg>
    ),
  },
  {
    title: 'Media',
    body: 'Pay creators, streamers and talent fast, with KYC-checked payouts.',
    icon: (
      <svg xmlns="http://www.w3.org/2000/svg" width="23" height="23" viewBox="0 0 23 23" fill="none">
        <path d="M11.5001 21.0837C16.7928 21.0837 21.0834 16.7931 21.0834 11.5003C21.0834 6.2076 16.7928 1.91699 11.5001 1.91699C6.20735 1.91699 1.91675 6.2076 1.91675 11.5003C1.91675 16.7931 6.20735 21.0837 11.5001 21.0837Z" stroke="#0043FE" strokeWidth="1.91667" strokeLinecap="round" strokeLinejoin="round"/>
        <path d="M9.58325 7.66699L15.3333 11.5003L9.58325 15.3337V7.66699Z" stroke="#0043FE" strokeWidth="1.91667" strokeLinecap="round" strokeLinejoin="round"/>
      </svg>
    ),
  },
  {
    title: 'Enterprise & Payroll',
    body: 'Run payroll and vendor payouts on a set schedule, every cycle.',
    icon: (
      <svg xmlns="http://www.w3.org/2000/svg" width="23" height="23" viewBox="0 0 23 23" fill="none">
        <rect x="3.5" y="8.5" width="16" height="11" rx="2" stroke="#0043FE" strokeWidth="1.91667" strokeLinecap="round" strokeLinejoin="round"/>
        <path d="M8.5 8.5V6C8.5 4.9 9.4 4 10.5 4H12.5C13.6 4 14.5 4.9 14.5 6V8.5" stroke="#0043FE" strokeWidth="1.91667" strokeLinecap="round" strokeLinejoin="round"/>
        <path d="M3.5 13.5H19.5" stroke="#0043FE" strokeWidth="1.91667" strokeLinecap="round" strokeLinejoin="round"/>
        <path d="M9.5 13.5V16.5M13.5 13.5V16.5" stroke="#0043FE" strokeWidth="1.91667" strokeLinecap="round" strokeLinejoin="round"/>
      </svg>
    ),
  },
];

export default function IndustriesSection() {
  return (
    <section className="industries">
      <img src={industriesBg} className="industries__bg" alt="" aria-hidden="true" />
      <div className="industries__overlay" />
      <div className="industries__wrapper">
        <div className="industries__header">
          <p className="industries__eyebrow">Industries</p>
          <h2 className="industries__heading">Payouts at work across your industry</h2>
          <p className="industries__description">settlor.money runs the payouts behind lenders, insurers, marketplaces and more.</p>
        </div>
        <div className="industries__container">
          {industries.map((item, i) => (
            <article key={i} className="industries__card">
              <div className="industries__card-icon">{item.icon}</div>
              <div className="industries__card-content">
                <h3 className="industries__card-title">{item.title}</h3>
                <p className="industries__card-description">{item.body}</p>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}
